export const V2_PAYROLL_ENTRY = "payroll.v2PayrollEntry";
